var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentDefaultsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA8F4E",
    d: "M13.065 18.7 12 18.086a4.935 4.935 0 0 0 0-2.17l1.06-.615a.5.5 0 0 0 .18-.683v-.001l-1.014-1.738a.5.5 0 0 0-.678-.184l-1.1.625A3.613 3.613 0 0 0 8.5 12.231V11a.5.5 0 0 0-.5-.5H6a.5.5 0 0 0-.5.5v1.23a3.617 3.617 0 0 0-1.936 1.09L2.46 12.7a.5.5 0 0 0-.678.184L.768 14.617a.5.5 0 0 0 .18.684l1.06.615a4.905 4.905 0 0 0 0 2.17L.935 18.7a.5.5 0 0 0-.184.683l.001.001 1 1.738a.5.5 0 0 0 .676.187l1.132-.629c.516.558 1.195.94 1.94 1.092V23a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1.228a3.617 3.617 0 0 0 1.936-1.09l1.133.629a.5.5 0 0 0 .676-.187l1-1.738a.5.5 0 0 0-.182-.683v-.001l.002-.002ZM7 19.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DA8F4E",
    d: "M19.5 2.492 21.508 4.5c.313.311.49.734.492 1.175v11.742a1.667 1.667 0 0 1-1.667 1.666h-5.662l-.92-.515a7.42 7.42 0 0 0 .249-.976.209.209 0 0 1 .2-.175h5.717a.416.416 0 0 0 .416-.417V5.85a.392.392 0 0 0-.125-.292l-1.766-1.766a.392.392 0 0 0-.292-.125H9.083a.417.417 0 0 0-.416.416v5.053A.642.642 0 0 0 8.269 9H7V3.667A1.667 1.667 0 0 1 8.667 2h9.658c.441.002.864.179 1.175.492Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DA8F4E",
    d: "m14.718 13.75-.9-1.5H18a.75.75 0 0 1 0 1.5h-3.282ZM12 6.25a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5H12ZM11.25 10a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDefaultsActive);
export default __webpack_public_path__ + "static/media/documentDefaults-active.cebcf69169dc5658e8808006cca01a12.svg";
export { ForwardRef as ReactComponent };